import { hasParsley } from '@/helpers/parsley'

export const PARSLEY_FALLBACK_PATH = '/store/products'

// A hidden page is hidden from its URL too, not only from the nav that links
// to it. Takes a getter rather than importing the store, so the rule can be
// tested without one. The router's beforeEach has loaded the user by the time
// a beforeEnter guard runs.
export const buildParsleyGuard = getUser => () => (hasParsley(getUser()) ? true : PARSLEY_FALLBACK_PATH)
